/* Carry the current selection into a quote without changing the cart flow. */
(() => {
  'use strict';
  if (customElements.get('tt-product-quote')) return;
  customElements.define('tt-product-quote', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-product-quote-link]') || this.querySelector('a');
      this.sdsLink = this.querySelector('[data-product-sds]');
      if (!this.link) return;
      try { this.variants = JSON.parse(this.dataset.variants); } catch (_) { this.variants = []; }
      this.update = () => {
        const form = document.getElementById(this.dataset.formId);
        if (!form) return;
        const id = form.elements.namedItem('id')?.value;
        const variant = this.variants.find(item => String(item.id) === String(id));
        const url = new URL(this.link.href);
        // An unavailable option combination must not retain the previous SKU.
        url.searchParams.delete('sku');
        url.searchParams.delete('variant');
        if (variant) {
          if (variant.sku) url.searchParams.set('sku', variant.sku);
          if (variant.title !== 'Default Title') url.searchParams.set('variant', variant.title);
        }
        if (!variant) {
          const picker = this.closest('product-info')?.querySelector('variant-selects');
          const requested = picker ? Array.from(picker.querySelectorAll('select,input:checked')).map(input => input.value).filter(Boolean) : [];
          if (requested.length) url.searchParams.set('variant', requested.join(' / '));
        }
        const quantity = form.elements.namedItem('quantity')?.value;
        url.searchParams.delete('quantity');
        if (/^[1-9]\d*$/.test(quantity || '')) url.searchParams.set('quantity', quantity);
        this.link.href = url.href;
        if (this.sdsLink) {
          const sdsUrl = new URL(this.sdsLink.href);
          sdsUrl.searchParams.delete('sku');
          if (variant?.sku) sdsUrl.searchParams.set('sku', variant.sku);
          this.sdsLink.href = sdsUrl.href;
        }
      };
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      // The theme dispatches change after updating the selected variant ID.
      this.closest('product-info')?.addEventListener('change', this.update, options);
      for (const event of ['focus', 'pointerenter', 'click', 'contextmenu']) {
        this.link.addEventListener(event, this.update, options);
        this.sdsLink?.addEventListener(event, this.update, options);
      }
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
})();

